import { request } from 'utils/axios';

const DEVICE_STORAGE_KEY = 'cway:web:analytics:device_id';

function getOrCreateWebDeviceId() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return 'web_unknown';
  }
  let id = localStorage.getItem(DEVICE_STORAGE_KEY);
  if (id && id.length >= 8 && id.length <= 191) {
    return id;
  }
  id =
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? `web_${crypto.randomUUID()}`
      : `web_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 14)}`;
  localStorage.setItem(DEVICE_STORAGE_KEY, id);
  return id;
}

function parsePositiveInt(value) {
  if (value == null || value === '') return null;
  const n = typeof value === 'number' ? value : parseInt(String(value), 10);
  if (!Number.isFinite(n) || n < 1) return null;
  return n;
}

function silent(promise) {
  promise.catch(() => {});
}

/**
 * Mirrors customer app `BackendAnalytics.productClick` — POST /analytics/product-click.
 */
export function trackProductClick(productId) {
  const product_id = parsePositiveInt(productId);
  if (product_id == null) return;
  const device_id = getOrCreateWebDeviceId();
  silent(
    request.post('analytics/product-click', {
      product_id,
      device_id,
    }),
  );
}

/**
 * Mirrors customer app `BackendAnalytics.advertClick` — POST /analytics/advert-click.
 * `advert_id` is `special_adds.id` (same as mobile `NewAdverts` / pop-up payloads).
 */
export function trackAdvertClick(advertId) {
  const advert_id = parsePositiveInt(advertId);
  if (advert_id == null) return;
  const device_id = getOrCreateWebDeviceId();
  silent(
    request.post('analytics/advert-click', {
      advert_id,
      device_id,
    }),
  );
}

/**
 * Mirrors customer app `BackendAnalytics.advertImpression` — POST /analytics/advert-impression.
 */
export function trackAdvertImpression(advertId) {
  const advert_id = parsePositiveInt(advertId);
  if (advert_id == null) return;
  const device_id = getOrCreateWebDeviceId();
  silent(
    request.post('analytics/advert-impression', {
      advert_id,
      device_id,
    }),
  );
}
